import React from "react"
import {Button} from "devextreme-react";


function FormActionButtons(props){

    const {cancelFunction, submitFunction, cancelText = "Cancelar", submitText= "Aceptar", disabled} = props;


    return(
        <div style={{paddingTop:10,paddingBottom:10,width:"100% !important"}}>
        <Button className="send"
            disabled={disabled}
            style={{float:"left"}}
            type="normal"
            onClick={ () => cancelFunction()}
            stylingMode="contained"
            text={cancelText}
        />
        <Button
            disabled={disabled}
            style={{float:"right"}}
            className="send"
            type="normal"
            stylingMode="contained"
            onClick={()=> submitFunction()}
            text={submitText}
        />
    </div> 
    )
}

export {FormActionButtons}